import { Theme, ThemeOptions } from '@mui/material';
export const formStyles = (theme: Theme): ThemeOptions => ({
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: theme.palette.error.main,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        multiline: {
          padding: '0.75rem 1.125rem',
        },
        inputMultiline: {
          padding: 0,
        },
      },
    },
    MuiMonthPicker: {
      styleOverrides: {
        root: {
          '.MuiTypography-h5': {
            fontSize: '1rem',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          display: 'flex',
          alignItems: 'center',
          minHeight: '3rem',
          '&.MuiInputBase-inputSizeSmall': {
            minHeight: '2.5rem',
          },
        },
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        openOnFocus: true,
        autoHighlight: true,
        blurOnSelect: true,
      },
      styleOverrides: {
        inputRoot: {
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
    },
  },
});
